// Change #100067 - retired products.
//
// Paul: "we have some products we dont want to be picked anymore ... however
// if i edit an invoice that uses an old one i still want it to show but i
// cant add anymore". Product.FlagActive = 0 retires a product.
//
// Missing / null FlagActive counts as ACTIVE: the column arrives with its own
// delta, and until that has run every product must still be pickable.

export const isProductActive = (product) =>
  String(product?.FlagActive ?? "1") !== "0";

// The products a picker should OFFER: every active product, plus any retired
// one that is already selected (keepIds), so an existing line still shows its
// product instead of going blank.
export const pickableProducts = (products = [], keepIds = []) => {
  const keep = new Set((keepIds || []).filter((id) => id !== null && id !== undefined && id !== "").map(String));
  return (products || []).filter(
    (product) => isProductActive(product) || keep.has(String(product?.Id))
  );
};
